import { BatchJobStatus } from '@/types/dataProcessing';

export const DATA_PROCESSING_POLL_INTERVAL_MS = 15_000;

export const DATA_PROCESSING_EXPECTED_DURATION = 'up to 5 minutes';

export const BATCH_JOB_STATUS: { readonly [Status in BatchJobStatus]: Status } = {
  SUBMITTED: 'SUBMITTED',
  PENDING: 'PENDING',
  RUNNABLE: 'RUNNABLE',
  STARTING: 'STARTING',
  RUNNING: 'RUNNING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
};

export const BATCH_JOB_STATUS_LABELS: Record<BatchJobStatus, string> = {
  SUBMITTED: 'Job submitted',
  PENDING: 'Waiting on dependencies',
  RUNNABLE: 'Queued, waiting for compute capacity',
  STARTING: 'Starting the processing container',
  RUNNING: 'Processing your files',
  SUCCEEDED: 'Completed successfully',
  FAILED: 'Failed',
};

export const BATCH_JOB_STATUS_BADGE_COLOR: Partial<Record<BatchJobStatus, string>> = {
  SUCCEEDED: 'green',
  FAILED: 'red',
};

export const DEFAULT_BADGE_COLOR = 'blue';
